module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bg_blue"
  }, [_c('div', {
    staticClass: "container_wrap"
  }, [_c('el-breadcrumb', {
    staticClass: "breadcrumb",
    attrs: {
      "separator-class": "el-icon-arrow-right"
    }
  }, [_c('el-breadcrumb-item', {
    attrs: {
      "to": {
        path: '/indexpc'
      }
    }
  }, [_vm._v("首页")]), _vm._v(" "), _c('el-breadcrumb-item', [_vm._v(" 考级测试")])], 1), _vm._v(" "), _c('el-alert', {
    staticClass: "elalert",
    attrs: {
      "title": "温馨提示",
      "type": "warning"
    }
  }, [_vm._v("\n      1.请根据自己的身份选择不同的考试类型"), _c('br'), _vm._v("\n      2.游客身份可以测试客观题，不可以测试实践题。"), _c('br'), _vm._v("\n      3.理论测试共20道选择题，16道单选题，4道多选题，得分大于等于总分的90%则通过客观题部分的测试并进入实践题测试；实践题共三道，可任选一道进行作答。"), _c('br')]), _vm._v(" "), _c('el-steps', {
    staticClass: "elsteps",
    attrs: {
      "space": 200,
      "active": 5,
      "finish-status": "success"
    }
  }, [_c('el-step', {
    attrs: {
      "title": "报名信息"
    }
  }), _vm._v(" "), _c('el-step', {
    attrs: {
      "title": "理论测试"
    }
  }), _vm._v(" "), _c('el-step', {
    attrs: {
      "title": "实践考试"
    }
  }), _vm._v(" "), _c('el-step', {
    attrs: {
      "title": "考级结果"
    }
  }), _vm._v(" "), _c('el-step', {
    attrs: {
      "title": "查看证书"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "left_and_right_container"
  }, [_c('div', {
    staticClass: "container_left"
  }, [_c('div', {
    staticClass: "container_left_content"
  }, [_c('div', {
    staticClass: "container_left_content_img"
  }, [_c('img', {
    attrs: {
      "src": _vm.row.user.face
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "container_left_content_name"
  }, [_c('span', [_vm._v("姓名：")]), _vm._v(_vm._s(_vm.row.user.name) + "\n          ")])])]), _vm._v(" "), _c('div', {
    staticClass: "container_center"
  }, [_c('el-form', {
    ref: "ruleForm",
    staticClass: "demo-ruleForm",
    attrs: {
      "model": _vm.formData,
      "rules": _vm.rules,
      "label-width": "100px"
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "收件人",
      "prop": "post_name"
    }
  }, [_c('el-input', {
    staticClass: "inputSizeClass",
    attrs: {
      "type": "text",
      "placeholder": "请输入收件人姓名"
    },
    model: {
      value: (_vm.formData.post_name),
      callback: function($$v) {
        _vm.$set(_vm.formData, "post_name", $$v)
      },
      expression: "formData.post_name"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "手机号",
      "prop": "post_phone"
    }
  }, [_c('el-input', {
    staticClass: "inputSizeClass",
    attrs: {
      "type": "text",
      "placeholder": "请输入手机号"
    },
    model: {
      value: (_vm.formData.post_phone),
      callback: function($$v) {
        _vm.$set(_vm.formData, "post_phone", $$v)
      },
      expression: "formData.post_phone"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "地区",
      "prop": "areas"
    }
  }, [_c('el-cascader', {
    staticClass: "inputSizeClass",
    attrs: {
      "options": _vm.areaOptions,
      "props": {
        label: 'title'
      }
    },
    model: {
      value: (_vm.formData.areas),
      callback: function($$v) {
        _vm.$set(_vm.formData, "areas", $$v)
      },
      expression: "formData.areas"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "详细地址",
      "prop": "address"
    }
  }, [_c('el-input', {
    staticClass: "inputSizeClass",
    attrs: {
      "type": "text",
      "placeholder": "请输入详细地址"
    },
    model: {
      value: (_vm.formData.address),
      callback: function($$v) {
        _vm.$set(_vm.formData, "address", $$v)
      },
      expression: "formData.address"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [(_vm.row.express_note) ? _c('el-alert', {
    attrs: {
      "title": '物流信息：' + _vm.row.express_note,
      "type": "success"
    }
  }) : _c('el-col', {
    staticClass: "btn_position_class"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.submitForm('ruleForm')
      }
    }
  }, [_vm._v("确定保存")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "plain": ""
    },
    on: {
      "click": function($event) {
        return _vm.resetForm('ruleForm')
      }
    }
  }, [_vm._v("重置")])], 1)], 1)], 1)], 1)])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-26726ebb","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/apps/kaoji/KaojiApplyPost.vue
// module id = 1171
// module chunks = 0